import jwt_decode from "jwt-decode";

export default function validateToken(token: string) {
  try {
    const decodedToken = jwt_decode(token);
    return decodedToken.exp < new Date();
  } catch (error) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/validateToken.ts